import { useKeycloak } from "@react-keycloak/web";
import React, { useEffect } from "react";
import PortalPreloader from "../../app/components/preloader/PortalPreloader";

const PrivateRoute = ({ element }) => {
  const { keycloak, initialized } = useKeycloak();

  useEffect(() => {
    if (!initialized) {
      // Keycloak is still initializing, handle accordingly (e.g., show loading spinner)
      // You might want to return here or show some loading indication until Keycloak is initialized.
      return;
    }

    if (!keycloak.authenticated) {
      // User is not authenticated, redirect to login page or handle as needed
      keycloak.login();
    }
  }, [keycloak, initialized]);

  if (!initialized) {
    // Keycloak is still initializing, you can return a loading spinner or other loading indication
    return <PortalPreloader />;
  }

  // If the user is authenticated, render the protected route
  if (keycloak.authenticated) {
    // User is not authenticated, redirect to login page or handle as needed
    return element;
  }
};

export default PrivateRoute;
